<template>
  <div>
    <div class="Blocks">
      <!-- <div class="Block_Top">
        <span>Top validators</span>
        <span>
      
          <div class="search">
            <input
              type="text"
              placeholder="Search for validation nodes address"
            />
            <img src="@/assets/pc/Index/seach.png" />
          </div>
        </span>
      </div> -->
      <div v-if="IsShowS == true">
        <div class="Block_list">
          <ul class="block_list_Top">
            <li>Rank</li>
            <li>Validators</li>
            <!-- <li>Address</li> -->
            <!-- <li>Version</li> -->
            <li>Delegators</li>
            <li>
              Workload<el-tooltip placement="right" popper-class="toolTipClass">
                <div slot="content">
                  The "Workload" value of a validator is a key metric for<br />
                  assessing its operational status. When the validator's<br />
                  "Workload" value reaches the standard threshold, it
                  indicates<br />
                  a well-functioning state, qualifying it to receive the full<br />
                  daily rewards. However, if the "Workload" value falls below<br />
                  the standard, it signifies that the validator's operational<br />
                  status requires improvement. In such cases, the validator<br />
                  cannot receive the full rewards but will only be eligible
                  to<br />
                  receive rewards based on the percentage of actual workload<br />
                  compared to the workload benchmark.
                  <!-- The "Workload" value of a validator is a crucial<br />
                  metric for assessing its operational status. When<br />
                  the "Workload" value of a validator meets the<br />
                  standard threshold, it indicates that the validator<br />
                  is in good working condition and eligible for<br />
                  receiving bonus. However, if the "Workload"<br />
                  value does not meet the standard, it implies that<br />
                  the validator's operational status needs<br />
                  improvement, and it won't be eligible to receive<br />
                  any bonus. -->
                  <!-- "The Workload" represents the operational state of
                  validators.<br />
                  Validators that meet the criteria will maintain a stable
                  "Workload"<br />
                  value, indicating that their data availability meets the<br />
                  requirements. However, when the value deviates from the
                  <br />expected range, it signifies that the validator's
                  operational state is <br />not up to the standard, resulting
                  in the inability to receive<br />
                  corresponding rewards. -->
                </div>
                <img src="@/assets/pc/Index/tip.png" />
              </el-tooltip>
            </li>
            <li>
              APY
              <el-tooltip placement="right" popper-class="toolTipClass">
                <div slot="content">Previous Epoch APY</div>
                <img
                  src="@/assets/pc/Index/tip.png"
                  style="
                    width: 13px;
                    height: 13px;
                    margin-top: 26px;
                    margin-left: 6px;
                  "
                />
              </el-tooltip>
            </li>
            <li @click="paixu">Self-Staked<img :src="PaixuImg" /></li>
            <li @click="paixu1">Delegator Stake<img :src="PaixuImg1" /></li>
            <!-- <li @click="paixu2">Total Staked<img :src="PaixuImg2" /></li> -->
            <li v-on:click.stop.prevent="UnactiveClick" ref="showPanel2">
              {{ Unactive }} <img :src="PaixuImg3" />
              <div class="Unactive" :style="{ height: UnactiveH + 'px' }">
                <div>
                  <p
                    v-on:click.stop.prevent="Active2"
                    :class="paixuId5 == 2 ? 'classActive' : ''"
                  >
                    Active
                  </p>
                  <p
                    v-on:click.stop.prevent="Active"
                    :class="paixuId5 == '' ? 'classActive' : ''"
                  >
                    Inactive
                  </p>
                </div>
              </div>
            </li>
            <li v-on:click.stop.prevent="OfflineClick">
              {{ Online2 }} <img :src="PaixuImg4" ref="showPanel" />
              <div class="Unactive" :style="{ height: UnactiveH2 + 'px' }">
                <div>
                  <p
                    v-on:click.stop.prevent="online4"
                    :class="paixuId4 == 2 ? 'classActive' : ''"
                  >
                    Online
                  </p>
                  <p
                    v-on:click.stop.prevent="Online1"
                    :class="paixuId4 == '' ? 'classActive' : ''"
                  >
                    Offline
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="Block_List_center">
          <ul>
            <li v-for="(item, index) in list" :key="index" class="notranslate">
              <p>{{ index + 20 * (pageNum - 1) + 1 }}</p>
              <p>
                <span @click="Online(index, delegated[index])"
                  ><img :src="item.logo" alt="" style="cursor: pointer"
                /></span>
                <span ref="ele" style="color: #fff">
                  <div class="name" @click="Online(index, delegated[index])">
                    {{ item.name === "" ? "Unknown" : item.name }}
                  </div>
                  <div class="adressall">
                    <span
                      @click="Online(index, delegated[index])"
                      class="adress"
                      >{{ item.address }}</span
                    ><img
                      src="../../../assets/pc/Index/fz.png"
                      v-clipboard:copy="item.address"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    />
                  </div>
                </span>
                <!-- <span ref="ele">{{
                  item.name === "" ? "Unknown" : item.name
                }}</span
                > -->
                <!-- <span @click="Online(index, delegated[index])">
                  {{ getSubStr(item.address) }}
                </span> -->
              </p>

              <!-- <p @click="Online(index, delegated[index])">
                {{ getSubStr(item.address) }}
              </p> -->
              <!-- <p>{{ item.version }}</p> -->
              <p>{{ Number(item.delegators).toLocaleString() }}</p>
              <!-- <p>{{ item.workload }}</p> -->
              <p v-if="parseInt(item.workload) >= parseInt(outlier)">
                <!-- <el-tooltip placement="right" popper-class="toolTipClass">
                <div slot="content"> -->
                {{ item.workload
                }}
                <!-- <el-tooltip placement="right" popper-class="toolTipClass">
                  <div slot="content">Bonus Earnings Percentage</div>
                  <img
                    src="@/assets/pc/Index/tip.png"
                    style="
                      width: 14px;
                      height: 14px;
                      margin-top: 25px;
                      margin-left: 6px;
                    "
                  />
                </el-tooltip> -->
                <!-- </div> -->
                <!-- <img src="@/assets/pc/Index/tip.png" />
              </el-tooltip> -->
              </p>
              <p v-else style="color: red">
                {{ item.workload
                }}
                <!-- <el-tooltip placement="right" popper-class="toolTipClass">
                  <div slot="content">Bonus Earnings Percentage</div>
                  <img
                    src="@/assets/pc/Index/tip.png"
                    style="
                      width: 14px;
                      height: 14px;
                      margin-top: 25px;
                      margin-left: 6px;
                    "
                  />
                </el-tooltip> -->
              </p>
              <p>{{ (item.pastPeriodAPY*100).toFixed(2) }}%</p>
              <p>{{ Number(item.selfStake).toLocaleString() }}</p>
              <p>
                <!-- {{ item.delegated }} -->
                <span
                  >{{ (item.delegated / 1000).toFixed(2) }}K / 65K ({{
                    item.Progressbar
                  }}%)
                </span>
                <span style="margin-left: 22px"
                  ><el-progress
                    style="width: 180px"
                    :percentage="Number(item.Progressbar)"
                    :color="customColor"
                  ></el-progress
                ></span>
              </p>
              <!-- <p>{{ item.totalStake }}</p> -->
              <p>
                <img
                  :src="item.active == 1 ? ImgUrl5 : ImgUrl4"
                  style="margin-right: 12px"
                />
              </p>
              <p :class="{ active: item.online != '1' }">
                {{ item.online != "1" ? "Offline" : "Online" }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="IsShowS == false">
        <div class="Img">
          <img src="@/assets/pc/BkHash/zanwushuju.png" alt="" />
        </div>
      </div>
      <div class="Block_List_Bottom">
        <div class="Block_List_Bottom_Pagination2">
          <!-- <Pagination2
            @PaginationChanage="CurrentChange($event)"
            :Total="total"
           
            :Page="Page1"
            :online3="Online3"
            :PaixuId3="paixuId3"
            :PaixuId4="paixuId4"
            v-if="IsShowS == true"
          /> -->
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="20"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../BlockList/Pagination";
import Pagination2 from "../BlockList/Pagination2.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
import { ValidatorRankList } from "@/assets/server/api";
export default {
  props: ["params"],
  data() {
    return {
      list: [],
      LogoImg: require("@/assets/pc/Index/vers.png"),
      ImgUrl: require("@/assets/pc/TopValidators/TopValidators1.png"),
      ImgUrl6: require("@/assets/pc/TopValidators/xiala.png"),
      ImgUrl2: require("@/assets/pc/TopValidators/TopValidators2.png"),
      ImgUrl3: require("@/assets/pc/TopValidators/TopValidators3.png"),
      ImgUrl4: require("@/assets/pc/TopValidators/TopValidators5.png"),
      ImgUrl5: require("@/assets/pc/Index/active.png"),
      ImgUrl7: require("@/assets/pc/TopValidators/xiala1.png"),
      PaixuImg: "",
      PaixuImg1: "",
      PaixuImg2: "",
      PaixuImg3: "",
      PaixuImg4: "",
      paixuId: "",
      paixuId1: "",
      paixuId2: "",
      paixuId3: null,
      paixuId4: null,
      paixuId5: null,
      PaginationIndex: 1,
      total: null,
      Address: [],
      delegated: [],
      Rank: [],
      Time: null,
      seqType: "",
      seq: "",
      Page1: 1,
      Unactive: "Active",
      Unactive2: "Inactive",
      UnactiveH: 0,
      Online2: "Online",
      Offline: "Offline",
      UnactiveH2: 0,
      Online3: "",
      IsShow: false,
      IsShowS: true,
      searchaddress: "",
      Actives: "",
      Onlines: "",
      outlier: "",
      // Actives: 1,
      // Onlines: 1,
      pageNum: 1,
      customColor: "#00E79A",
      // CurrentAPR: "",
      // stakeRate: "",
      // nextDuring: 0,
      // versionList: [],
      // nodeCount: 0, //节点数量
      // validatorCount: 0, //验证器数量
      // totalStake: 0,
    };
  },
  components: {
    Pagination,
    Pagination2,
    EmptyState,
  },
  created() {
    sessionStorage.removeItem("onlines");
    this.PaixuImg = this.ImgUrl;
    this.PaixuImg1 = this.ImgUrl;
    this.PaixuImg2 = this.ImgUrl;
    this.PaixuImg3 = this.ImgUrl6;
    this.PaixuImg4 = this.ImgUrl6;

    document.addEventListener("click", (e) => {
      if (this.$refs.showPanel) {
        let isSelf = this.$refs.showPanel.contains(e.target);
        if (!isSelf) {
          this.UnactiveH2 = 0;
          this.IsShow = false;
        }
      }
    });
    document.addEventListener("click", (e) => {
      if (this.$refs.showPanel2) {
        let isSelf = this.$refs.showPanel2.contains(e.target);
        if (!isSelf) {
          this.UnactiveH = 0;
          this.IsShow = false;
        }
      }
    });

    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  mounted() {
    // this.PaixuImg = this.ImgUrl;
    //     this.PaixuImg1 = this.ImgUrl;
    //     this.PaixuImg2 = this.ImgUrl;
    let fanyi2 = this.getContextData("saixuan1");
    let fanyi3 = this.getContextData("saixuan2");
    let fanyi4 = this.getContextData("saixuan3");
    let fanyi5 = this.getContextData("saixuan4");
    if (fanyi2 != undefined) {
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("saixuan4");
      sessionStorage.removeItem("tiaozhuan");
      this.PaginationIndex = this.getContextData("saixuan1") || 1;
    } else if (fanyi3 != undefined) {
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("saixuan4");
      sessionStorage.removeItem("tiaozhuan");
      this.PaginationIndex = this.getContextData("saixuan2") || 1;
    } else if (fanyi4 != undefined) {
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan4");
      sessionStorage.removeItem("tiaozhuan");
      this.PaginationIndex = this.getContextData("saixuan3") || 1;
    } else if (fanyi5 != undefined) {
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("tiaozhuan");
      this.PaginationIndex = this.getContextData("saixuan4") || 1;
    } else {
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("saixuan4");
      this.PaginationIndex = 1;
    }
    let aa = sessionStorage.getItem("Unactive");
    if (aa != null && aa == 1) {
      this.Active();
    } else if (aa != null && aa == 2) {
      this.Active2();
    } else if (aa != null && aa == 3) {
      this.Online1();
    } else if (aa != null && aa == 4) {
      this.online4();
    } else {
      this.ValidakList();
    }
  },
  watch: {
    deep: true,
    params(val) {
      //  console.log(val);
      this.list = val.ListParams;
      //   console.log(this.list);
      this.total = val.count;
      //    console.log(this.total);
      this.searchaddress = val.address;
      //    console.log(this.searchaddress);
      this.IsShowS = val.IsShows;
      this.PaixuImg = this.ImgUrl;
      this.PaixuImg1 = this.ImgUrl;
      this.Unactive = "Active";
      this.Online2 = "Online";
      this.paixuId5 = 3;
      this.paixuId4 = 3;
      this.Actives = val.active;
      this.Onlines = val.online;

      // this.PaginationIndex = 1;
      // sessionStorage.removeItem("qingcu");

      //   sessionStorage.removeItem("tupian1");
      //   sessionStorage.removeItem("tupian");
      if (val.ImgUrl != undefined) {
        for (let i = 0; i < val.ImgUrl.length; i++) {
          this.list[i].logo = val.ImgUrl[i];
        }
      }
    },
  },
  methods: {
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this.ValidakList();
    },
    goBack() {
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("saixuan4");
      sessionStorage.removeItem("qingcu");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("Unactive");
      this.$store.commit("Pagination", 1);
      this.IsShowS = true;
      this.ValidakList();
    },
    paixu() {
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("saixuan4");
      sessionStorage.setItem("qingcu", 2);
      this.$store.commit("Pagination", 1);
      this.Page1 = 1;
      this.PaginationIndex = 1;
      this.pageNum = 1;
      // debugger;
      sessionStorage.removeItem("Unactive");
      sessionStorage.removeItem("tupian1");
      sessionStorage.removeItem("tupian2");
      sessionStorage.removeItem("tiaozhuan");
      this.Actives = "";
      this.Onlines = "";
      if (this.paixuId === "") {
        // alert(1);
        this.setContextData("tupian", 1);
        this.PaixuImg = this.ImgUrl2;
        this.PaixuImg2 = this.ImgUrl;
        this.PaixuImg1 = this.ImgUrl;
        this.PaixuImg3 = this.ImgUrl6;
        this.PaixuImg4 = this.ImgUrl6;
        this.paixuId = 2;
        this.seqType = "seftStake";
        this.seq = "asc";

        this.ValidakList();
        // this.fanyeBioaji = 1;
        // this.fanyeBioaji1 = 0;
        // this.fanyeBioaji2 = 0;
        // this.list.sort((a, b) => {
        //   return a.selfStake - b.selfStake;
        // });
        // this.delegated.sort((a, b) => {
        //   return a - b;
        // });
      } else if (this.paixuId === 2) {
        this.setContextData("tupian", 11);
        this.PaixuImg = this.ImgUrl3;
        this.PaixuImg2 = this.ImgUrl;
        this.PaixuImg1 = this.ImgUrl;
        this.PaixuImg3 = this.ImgUrl6;
        this.PaixuImg4 = this.ImgUrl6;
        this.paixuId = "";
        this.seqType = "seftStake";
        this.seq = "desc";
        this.ValidakList();
        // this.fanyeBioaji = 2;
        // this.fanyeBioaji1 = 0;
        // this.fanyeBioaji2 = 0;
        // this.list.sort((a, b) => {
        //   return b.selfStake - a.selfStake;
        // });
        // this.delegated.sort((a, b) => {
        //   return b - a;
        // });
      }
    },
    paixu1() {
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("tupian2");
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("saixuan4");
      sessionStorage.removeItem("tiaozhuan");
      sessionStorage.setItem("qingcu", 3);
      this.$store.commit("Pagination", 1);
      this.Actives = "";
      this.Onlines = "";
      this.Page1 = 1;
      this.PaginationIndex = 1;
      this.pageNum = 1;
      // debugger;
      sessionStorage.removeItem("Unactive");
      if (this.paixuId1 === "") {
        // alert(11);
        // debugger
        this.setContextData("tupian1", 1);
        this.PaixuImg1 = this.ImgUrl2;
        this.PaixuImg = this.ImgUrl;
        this.PaixuImg2 = this.ImgUrl;
        this.PaixuImg3 = this.ImgUrl6;
        this.PaixuImg4 = this.ImgUrl6;
        this.paixuId1 = 2;
        this.seqType = "delegated";
        this.seq = "asc";
        this.ValidakList();
        // this.fanyeBioaji = 0;
        // this.fanyeBioaji1 = 1;
        // this.fanyeBioaji2 = 0;
        // this.list.sort((a, b) => {
        //   return a.delegated - b.delegated;
        // });
        // this.delegated.sort((a, b) => {
        //   return a - b;
        // });
      } else if (this.paixuId1 === 2) {
        this.setContextData("tupian1", 11);

        // debugger
        this.PaixuImg1 = this.ImgUrl3;
        this.PaixuImg = this.ImgUrl;
        this.PaixuImg2 = this.ImgUrl;
        this.PaixuImg3 = this.ImgUrl6;
        this.PaixuImg4 = this.ImgUrl6;
        this.paixuId1 = "";
        this.seqType = "delegated";
        this.seq = "desc";
        this.ValidakList();
        // this.fanyeBioaji = 0;
        // this.fanyeBioaji1 = 2;
        // this.fanyeBioaji2 = 0;
        // this.list.sort((a, b) => {
        //   return b.delegated - a.delegated;
        // });
        // this.delegated.sort((a, b) => {
        //   return b - a;
        // });
      }
    },
    paixu2() {
      sessionStorage.removeItem("tupian1");
      sessionStorage.removeItem("tupian");
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("saixuan4");
      sessionStorage.removeItem("tiaozhuan");
      sessionStorage.setItem("qingcu", 4);
      this.$store.commit("Pagination", 1);
      this.Actives = "";
      this.Onlines = "";
      this.Page1 = 1;
      this.PaginationIndex = 1;
      this.pageNum = 1;
      // debugger;
      sessionStorage.removeItem("Unactive");
      if (this.paixuId2 === "") {
        this.setContextData("tupian2", 1);
        this.PaixuImg2 = this.ImgUrl2;
        this.PaixuImg = this.ImgUrl;
        this.PaixuImg1 = this.ImgUrl;
        this.PaixuImg3 = this.ImgUrl6;
        this.PaixuImg4 = this.ImgUrl6;
        this.paixuId2 = 2;
        this.seqType = "totalStake";
        this.seq = "asc";
        this.ValidakList();
        // this.fanyeBioaji = 0;
        // this.fanyeBioaji1 = 0;
        // this.fanyeBioaji2 = 1;
        // this.delegated.sort((a, b) => {
        //   return a - b;
        // });
        // this.list.sort((a, b) => {
        //   return a.selfStake - b.selfStake;
        // });
        // this.list.sort((a, b) => {
        //   return a.delegated - b.delegated;
        // });
      } else if (this.paixuId2 === 2) {
        this.setContextData("tupian2", 11);
        this.PaixuImg2 = this.ImgUrl3;
        this.PaixuImg = this.ImgUrl;
        this.PaixuImg1 = this.ImgUrl;
        this.PaixuImg3 = this.ImgUrl6;
        this.PaixuImg4 = this.ImgUrl6;
        this.paixuId2 = "";
        this.seqType = "totalStake";
        this.seq = "desc";
        this.ValidakList();
        // this.fanyeBioaji = 0;
        // this.fanyeBioaji1 = 0;
        // this.fanyeBioaji2 = 2;
        // this.delegated.sort((a, b) => {
        //   return b - a;
        // });
        // this.list.sort((a, b) => {
        //   return b.delegated - a.delegated;
        // });
        // this.list.sort((a, b) => {
        //   return b.selfStake - a.selfStake;
        // });
      }
    },
    // paixu2() {
    //   sessionStorage.removeItem("tupian1");
    //   sessionStorage.removeItem("tupian");
    //   sessionStorage.removeItem("saixuan1");
    //   sessionStorage.removeItem("saixuan2");
    //   sessionStorage.removeItem("saixuan3");
    //   sessionStorage.removeItem("saixuan4");
    //   sessionStorage.removeItem("tiaozhuan");
    //   sessionStorage.setItem("qingcu", 4);
    //   this.$store.commit("Pagination", 1);
    //   this.Page1 = 1;
    //   this.PaginationIndex = 1;
    //   sessionStorage.removeItem("Unactive");
    //   if (this.paixuId2 === "") {
    //     this.setContextData("tupian2", 1);
    //     this.PaixuImg2 = this.ImgUrl2;
    //     this.PaixuImg = this.ImgUrl;
    //     this.PaixuImg1 = this.ImgUrl;
    //     this.PaixuImg3 = this.ImgUrl6;
    //     this.PaixuImg4 = this.ImgUrl6;
    //     this.paixuId2 = 2;
    //     this.seqType = "totalStake";
    //     this.seq = "asc";
    //     this.ValidakList();
    //   } else if (this.paixuId2 === 2) {
    //     this.setContextData("tupian2", 11);
    //     this.PaixuImg2 = this.ImgUrl3;
    //     this.PaixuImg = this.ImgUrl;
    //     this.PaixuImg1 = this.ImgUrl;
    //     this.PaixuImg3 = this.ImgUrl6;
    //     this.PaixuImg4 = this.ImgUrl6;
    //     this.paixuId2 = "";
    //     this.seqType = "totalStake";
    //     this.seq = "desc";
    //     this.ValidakList();
    //   }
    // },
    CurrentChange(e) {
      // console.log(e);
      this.PaginationIndex = e;
      this.Page1 = e;
    },
    ValidakList(e) {
      var imgs = this.getContextData("tupian");
      var imgs1 = this.getContextData("tupian1");
      var imgs2 = this.getContextData("tupian2");
      //   console.log(imgs);
      //   console.log(imgs1);
      //    console.log(imgs2);
      // if (imgs == 1) {
      //   this.PaixuImg = this.ImgUrl2;
      //   this.seqType = "seftStake";
      //   this.seq = "asc";
      // } else if (imgs == 11) {
      //   this.PaixuImg = this.ImgUrl3;
      //   this.seqType = "seftStake";
      //   this.seq = "desc";
      // }
      // if (imgs1 == 1) {
      //   this.PaixuImg1 = this.ImgUrl2;
      //   this.seqType = "delegated";
      //   this.seq = "asc";
      // } else if (imgs1 == 11) {
      //   this.PaixuImg1 = this.ImgUrl3;
      //   this.seqType = "delegated";
      //   this.seq = "desc";
      // }

      // if (imgs2 == 1) {
      //   this.PaixuImg2 = this.ImgUrl2;
      //   this.seqType = "totalStake";
      //   this.seq = "asc";
      // } else if (imgs2 == 11) {
      //   this.PaixuImg2 = this.ImgUrl3;
      //   this.seqType = "totalStake";
      //   this.seq = "desc";
      // }
      this.paixuId5 = null;
      this.paixuId4 = null;
      this.Unactive = "Active";
      this.Online2 = "Online";
      this.Page1 = this.Page1;
      if (e != undefined) {
        this.PaginationIndex = 1;
        this.Page1 = 1;
      }
      // if (this.searchaddress == "" || this.searchaddress == undefined) {

      //   // this.Actives = "";
      //   // this.Onlines = "";
      //   this.seqType="";
      //   this.seq='';
      //      // seqType: 'delegated',
      //     // seq: 'desc',
      // }
      // this.Actives = this.getContextData("actives");
      // this.Onlines = this.getContextData("onlines");

      const params = {
        pageNum: this.pageNum,
        pageSize: 20,
        seqType: this.seqType,
        seq: this.seq,
        active: this.Actives,
        online: this.Onlines,
      };
      //  console.log(params);
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      ValidatorRankList(formData).then((res) => {
        // console.log(res);
        this.total = res.result.listCount;
        this.outlier = res.result.workloadBenchMark;
        //      console.log(this.total);
        this.list = res.result.validatorList;
            //console.log(this.list);
        this.PaginationIndex = 1;
        // this.CurrentAPR = res.result.CurrentAPR;
        // this.stakeRate = res.result.stakeRate;
        // this.nextDuring = res.result.nextDuring;
        // this.versionList = res.result.versionList;
        // this.nodeCount = res.result.nodeCount;
        // this.validatorCount = res.result.validatorCount;
        // this.totalStake = res.result.totalStake;
        for (let i = 0; i < this.list.length; i++) {
          this.Address[i] = this.list[i].address;
          this.Address[i] = this.getSubStr(this.Address[i]);
          this.delegated[i] = this.add(
            this.list[i].selfStake,
            this.list[i].delegated
          );

          if (this.list[i].logo === "") {
            this.list[i].logo = this.LogoImg;
          }
          this.list[i].Progressbar = (
            (this.list[i].delegated / 1000000 / 0.065) *
            100
          ).toFixed(2);
          // console.log(this.list[i].Progressbar);
        }

        let params = {
          CurrentAPR: res.result.CurrentAPR,
          stakeRate: (parseFloat(res.result.stakeRate) * 100).toFixed(3),
          nextDuring: res.result.nextDuring,
          versionList: res.result.versionList,
          nodeCount: res.result.nodeCount,
          validatorCount: res.result.validatorCount,
          totalStake: res.result.totalStake,
          workloadBenchMark: res.result.workloadBenchMark,
          outlier: res.result.outlier,
        };
        this.$emit("ValidakList", params);
      });
    },
    Online(index, delegated) {
      let params = {
        address: this.list[index].address,
        // active: this.list[index].active,
        // online: this.list[index].online,
        // selfStake: this.list[index].selfStake,
        // delegateds: this.list[index].delegated,
        // delegated: delegated,
        // name: this.$refs.ele[index].innerHTML,
        // version: this.list[index].version,
      };
      this.$router.push({
        path: "/pc/ValidatorDetail",
        query: params,
      });
    },
    getSubStr(str) {
      var subStr1 = str.substr(0, 3);
      var subStr2 = str.substr(str.length - 6, 3);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    add() {
      let _args = arguments;
      let _pointArray = Array.prototype.map.call(_args, (item) => {
        let _itemArray = item.toString().split(".");
        return _itemArray.length > 1 ? _itemArray[1].length : 0;
      });
      let _maxPoint = Math.max.apply(null, _pointArray);
      let _scale = Math.pow(10, _maxPoint);
      return (
        Array.prototype.reduce.apply(_args, [(a, b) => a + b * _scale, 0]) /
        _scale
      );
    },
    onCopy(e) {
      //console.log(e);
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
    async Active() {
      // debugger
      // alert(1);
      //this.Actives = 0;
      sessionStorage.removeItem("actives1");
      this.setContextData("actives", 0);
      this.Actives = this.getContextData("actives");
      sessionStorage.removeItem("qingcu");
      // console.log("qqq");
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("saixuan4");
      sessionStorage.removeItem("tiaozhuan");
      // this.$store.commit("Pagination",1)
      // this.Page1 = this.getContextData("saixuan2") || 1;
      let Page = this.getContextData("saixuan2");
      if (Page == undefined) {
        this.Page1 = 1;
        this.PaginationIndex = 1;
      } else if (Page != undefined) {
        // sessionStorage.getItem("saixuan2");
        this.Page1 = Page;
        this.PaginationIndex = Page;
      }
      this.pageNum = 1;
      // this.PaginationIndex = this.getContextData("tiaozhuan") || 1;
      this.Onlines = 1;
      this.paixuId3 = "";
      this.paixuId4 = "";
      this.paixuId5 = "";
      // this.Page1 = 1;
      // debugger
      sessionStorage.setItem("Unactive", 1);
      if (this.paixuId3 == "") {
        this.Unactive = "Inactive";
        this.IsShow = false;
        this.UnactiveH = 0;
        // this.PaixuImg3 = this.ImgUrl7;
        this.PaixuImg = this.ImgUrl;
        this.PaixuImg1 = this.ImgUrl;
        this.PaixuImg2 = this.ImgUrl;
        // this.PaixuImg4 = this.ImgUrl6;
        const params1 = {
          pageNum: this.Page1,
          pageSize: 20,
          active: this.Actives,
          online: this.Onlines,
        };
        if (this.Onlines == 1) {
          //  console.log("我是在线问");
          this.paixuId4 = 2;
          this.Online2 = "Online";
        } else if (this.Onlines == 0) {
          this.paixuId4 = "";
          this.Online2 = "Offline";
        }
        //  console.log(params1);
        const formData = new FormData();
        const item = params1;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let data = await ValidatorRankList(formData);
        this.list = data.result.validatorList;
        this.total = data.result.listCount;
        for (let i = 0; i < this.list.length; i++) {
          // this.list[i].height = res.result.height - this.list[i].height;
          // console.log(this.list[i].height);
          // console.log(this.list[i]);
          this.Address[i] = this.list[i].address;
          this.Address[i] = this.getSubStr(this.Address[i]);
          this.delegated[i] = this.add(
            this.list[i].selfStake,
            this.list[i].delegated
          );
          this.list[i].Progressbar = (
            (this.list[i].delegated / 1000000 / 0.065) *
            100
          ).toFixed(2);
          if (this.list[i].logo === "") {
            this.list[i].logo = this.LogoImg;
          }
        }
        let params = {
          yieldOfStake: data.result.yieldOfStake,
          stakeRate: data.result.stakeRate,
          totalStake: data.result.totalStake,
          nextDuring: data.result.nextDuring,
          allNodeSize: data.result.allNodeSize,
          count: data.result.validators,
          CurrentAPR: data.result.CurrentAPR,
          validatorCount: data.result.validatorCount,
          workloadBenchMark: data.result.workloadBenchMark,
          versionList: data.result.versionList,
          outlier: res.result.outlier,
        };
        // console.log(params);
        this.$emit("ValidakList", params);
        // console.log("this.total", this.total);
        let list2 = [];
        for (let i = 0; i < this.list.length; i++) {
          // this.list[i].height = data.result.height - this.list[i].height;
          this.Address[i] = this.list[i].address;
          this.Address[i] = this.getSubStr(this.Address[i]);
          this.delegated[i] = this.add(
            this.list[i].selfStake,
            this.list[i].delegated
          );
          // if (this.list[i].logo === "") {
          //   this.list[i].logo = this.LogoImg;
          // }
          if (this.list[i].active == "0") {
            list2.push(this.list[i]);
          }
        }
        this.list = list2;
      }
    },
    //活跃Active
    async Active2() {
      // debugger
      //this.Actives = 1;
      sessionStorage.removeItem("actives");
      this.setContextData("actives", 1);
      this.Actives = this.getContextData("actives");
      // this.setContextData("actives1", 1);
      // this.Actives = this.getContextData("actives1");
      // console.log(this.Active2);
      sessionStorage.removeItem("qingcu");
      // console.log("121221");
      sessionStorage.removeItem("tiaozhuan");
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan4");
      // this.$store.commit("Pagination",1)
      sessionStorage.removeItem("saixuan3");
      // let Page = sessionStorage.getItem("saixuan1");
      // let Page = this.getContextData("saixuan1");

      this.pageNum = 1;

      this.Onlines = 1;
      // debugger
      this.paixuId3 = 2;
      this.paixuId4 = null;
      this.paixuId5 = 2;
      // this.Page1 = 1;
      // debugger
      sessionStorage.setItem("Unactive", 2);
      if (this.paixuId3 == 2) {
        this.IsShow = false;
        this.Unactive = "Active";
        // this.Unactive2 = "Unactive";
        this.UnactiveH = 100;
        // this.PaixuImg3 = this.ImgUrl6;
        this.PaixuImg = this.ImgUrl;
        this.PaixuImg1 = this.ImgUrl;
        this.PaixuImg2 = this.ImgUrl;
        //console.log(this.Onlines);
        // this.PaixuImg4 = this.ImgUrl6;
        const params1 = {
          pageNum: this.Page1,
          pageSize: 20,
          active: this.Actives,
          online: this.Onlines,
        };
        if (this.Onlines == 1) {
          // console.log("我是在线");
          this.paixuId4 = 2;
          this.Online2 = "Online";
        } else if (this.Onlines == 0) {
          this.paixuId4 = "";
          this.Online2 = "Offline";
        }
        //console.log(params1);
        const formData = new FormData();
        const item = params1;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let data = await ValidatorRankList(formData);
        this.list = data.result.validatorList;
        this.total = data.result.listCount;
        for (let i = 0; i < this.list.length; i++) {
          // this.list[i].height = res.result.height - this.list[i].height;
          // console.log(this.list[i].height);
          // console.log(this.list[i]);
          this.Address[i] = this.list[i].address;
          this.Address[i] = this.getSubStr(this.Address[i]);
          this.delegated[i] = this.add(
            this.list[i].selfStake,
            this.list[i].delegated
          );
          this.list[i].Progressbar = (
            (this.list[i].delegated / 1000000 / 0.065) *
            100
          ).toFixed(2);
          if (this.list[i].logo === "") {
            this.list[i].logo = this.LogoImg;
          }
        }
        let params = {
          yieldOfStake: data.result.yieldOfStake,
          stakeRate: data.result.stakeRate,
          totalStake: data.result.totalStake,
          nextDuring: data.result.nextDuring,
          allNodeSize: data.result.allNodeSize,
          count: data.result.validators,
          CurrentAPR: data.result.CurrentAPR,
          validatorCount: data.result.validatorCount,
          workloadBenchMark: data.result.workloadBenchMark,
          versionList: data.result.versionList,
          outlier: res.result.outlier,
        };
        this.$emit("ValidakList", params);
        let list2 = [];
        for (let i = 0; i < this.list.length; i++) {
          // this.list[i].height = data.result.height - this.list[i].height;
          this.Address[i] = this.list[i].address;
          this.Address[i] = this.getSubStr(this.Address[i]);
          this.delegated[i] = this.add(
            this.list[i].selfStake,
            this.list[i].delegated
          );
          // if (this.list[i].logo === "") {
          //   this.list[i].logo = this.LogoImg;
          // }
          if (this.list[i].active == "1") {
            list2.push(this.list[i]);
          }
        }
        this.list = list2;
      }
    },
    //是否活跃
    // UnactiveClick() {
    //   this.UnactiveH2 = 0;
    //   if (this.IsShow == false) {
    //     this.IsShow = true;
    //     this.UnactiveH = 100;
    //     // this.PaginationIndex = 1;
    //     // sessionStorage.removeItem("Unactive")
    //   } else if (this.IsShow == true) {
    //     this.IsShow = false;
    //     this.UnactiveH = 0;
    //   }
    // },
    // 修改Online文本和选功能
    async Online1() {
      //  alert(23);
      // this.Onlines = 0;
      // this.Actives = 0;
      sessionStorage.removeItem("onlines1");
      this.setContextData("onlines", 0);
      this.Onlines = this.getContextData("onlines");
      // console.log(this.Onlines);

      // this.Page1 = 1;
      // 控制子组件动态函数
      this.Online3 = 2;
      sessionStorage.removeItem("qingcu");
      this.paixuId4 = "";
      sessionStorage.setItem("Unactive", 3);
      this.paixuId3 = null;
      // 设置classActive名字
      this.paixuId5 = null;
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan2");
      // this.$store.commit("Pagination",1)
      sessionStorage.removeItem("saixuan3");
      sessionStorage.removeItem("tiaozhuan");
      let Page = this.getContextData("saixuan4");
      if (Page == undefined) {
        this.Page1 = 1;
        this.PaginationIndex = 1;
      } else if (Page != undefined) {
        // sessionStorage.getItem("saixuan2");
        this.Page1 = Page;
        this.PaginationIndex = Page;
      }
      this.pageNum = 1;
      if (this.paixuId4 == "") {
        // 设置点击任何地方隐藏下拉框
        this.IsShow = false;
        this.Online2 = "Offline";
        this.Offline = "Online";
        this.UnactiveH2 = 0;
        // 设置图片
        // this.PaixuImg3 = this.ImgUrl6;
        this.PaixuImg = this.ImgUrl;
        this.PaixuImg1 = this.ImgUrl;
        this.PaixuImg2 = this.ImgUrl;
        if (this.Actives == 1) {
          // console.log("我是活跃");
          this.Unactive = "Active";
          this.paixuId5 = 2;
        } else if (this.Actives == 0) {
          this.Unactive = "Inactive";
          this.paixuId5 = "";
        }
        // this.PaixuImg4 = this.ImgUrl7;
        const params1 = {
          pageNum: this.Page1,
          pageSize: 20,
          active: this.Actives,
          online: this.Onlines,
          // seqType: this.seqType,
          // seq: this.seq,
        };
        // console.log(params1);
        const formData = new FormData();
        const item = params1;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let data = await ValidatorRankList(formData);
        //    console.log(data);
        this.list = data.result.validatorList;
        this.total = data.result.listCount;
        for (let i = 0; i < this.list.length; i++) {
          // this.list[i].height = res.result.height - this.list[i].height;
          // console.log(this.list[i].height);
          // console.log(this.list[i]);
          this.Address[i] = this.list[i].address;
          this.Address[i] = this.getSubStr(this.Address[i]);
          this.delegated[i] = this.add(
            this.list[i].selfStake,
            this.list[i].delegated
          );
          this.list[i].Progressbar = (
            (this.list[i].delegated / 1000000 / 0.065) *
            100
          ).toFixed(2);
          if (this.list[i].logo === "") {
            this.list[i].logo = this.LogoImg;
          }
        }
        let params = {
          yieldOfStake: data.result.yieldOfStake,
          stakeRate: data.result.stakeRate,
          totalStake: data.result.totalStake,
          allNodeSize: data.result.allNodeSize,
          nextDuring: data.result.nextDuring,
          count: data.result.validators,
          CurrentAPR: data.result.CurrentAPR,
          validatorCount: data.result.validatorCount,
          workloadBenchMark: data.result.workloadBenchMark,
          versionList: data.result.versionList,
          outlier: res.result.outlier,
        };
        this.$emit("ValidakList", params);
      }
    },
    async online4() {
      // this.Onlines = 1;
      if (this.Actives == undefined) {
        this.Actives = 1;
      }
      sessionStorage.removeItem("onlines");
      this.setContextData("onlines", 1);
      this.Onlines = this.getContextData("onlines");
      // this.setContextData("onlines1", 1);
      // this.Onlines = this.getContextData("onlines1");
      // this.Page1 = 1;
      this.Online3 = 2;
      sessionStorage.removeItem("qingcu");
      this.paixuId4 = 2;
      this.paixuId5 = null;
      this.paixuId3 = null;
      sessionStorage.removeItem("saixuan1");
      sessionStorage.removeItem("saixuan2");
      sessionStorage.removeItem("saixuan4");
      // this.$store.commit("Pagination",1)
      sessionStorage.removeItem("tiaozhuan");
      let Page = this.getContextData("saixuan3");
      if (Page == undefined) {
        this.Page1 = 1;
        this.PaginationIndex = 1;
      } else if (Page != undefined) {
        // sessionStorage.getItem("saixuan2");
        this.Page1 = Page;
        this.PaginationIndex = Page;
      }
      this.pageNum = 1;
      sessionStorage.setItem("Unactive", 4);
      if (this.paixuId4 == 2) {
        this.IsShow = false;
        this.Online2 = "Online";
        this.Offline = "Offline";
        this.UnactiveH2 = 0;
        // this.PaixuImg4 = this.ImgUrl6;
        // this.PaixuImg3 = this.ImgUrl6;
        this.PaixuImg = this.ImgUrl;
        this.PaixuImg1 = this.ImgUrl;
        this.PaixuImg2 = this.ImgUrl;
        const params1 = {
          pageNum: this.Page1,
          pageSize: 20,
          active: this.Actives,
          online: this.Onlines,
        };
        //   console.log(params1);
        if (this.Actives == 1) {
          // console.log("我是活跃");
          this.paixuId5 = 2;
          this.Unactive = "Active";
        } else if (this.Actives == 0) {
          this.paixuId5 = "";
          this.Unactive = "Inactive";
        }

        const formData = new FormData();
        const item = params1;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let data = await ValidatorRankList(formData);
        this.list = data.result.validatorList;
        this.total = data.result.listCount;
        for (let i = 0; i < this.list.length; i++) {
          // this.list[i].height = res.result.height - this.list[i].height;
          // console.log(this.list[i].height);
          // console.log(this.list[i]);
          this.Address[i] = this.list[i].address;
          this.Address[i] = this.getSubStr(this.Address[i]);
          this.delegated[i] = this.add(
            this.list[i].selfStake,
            this.list[i].delegated
          );
          this.list[i].Progressbar = (
            (this.list[i].delegated / 1000000 / 0.065) *
            100
          ).toFixed(2);
          if (this.list[i].logo === "") {
            this.list[i].logo = this.LogoImg;
          }
        }
        let params = {
          yieldOfStake: data.result.yieldOfStake,
          stakeRate: data.result.stakeRate,
          totalStake: data.result.totalStake,
          nextDuring: data.result.nextDuring,
          allNodeSize: data.result.allNodeSize,
          count: data.result.validators,
          CurrentAPR: data.result.CurrentAPR,
          validatorCount: data.result.validatorCount,
          workloadBenchMark: data.result.workloadBenchMark,
          versionList: data.result.versionList,
          outlier: res.result.outlier,
        };
        this.$emit("ValidakList", params);
      }
    },
    //是否在线
    // OfflineClick() {
    //   this.UnactiveH = 0;
    //   if (this.IsShow == false) {
    //     this.UnactiveH2 = 100;
    //     this.IsShow = true;
    //     // this.PaginationIndex = 1;
    //   } else if (this.IsShow == true) {
    //     this.IsShow = false;
    //     this.UnactiveH2 = 0;
    //   }
    // },
    //是否活跃
    UnactiveClick() {
      this.Onlines = this.getContextData("onlines");
      //console.log(this.Onlines);
      this.Actives = this.getContextData("actives");
      // console.log(this.Actives);
      this.UnactiveH2 = 0;
      if (this.IsShow == false) {
        this.IsShow = true;
        this.UnactiveH = 100;
        // this.PaginationIndex = 1;
        // sessionStorage.removeItem("Unactive")
      } else if (this.IsShow == true) {
        this.IsShow = false;
        this.UnactiveH = 0;
      }
      // else if (this.Onlines == 0 && this.Actives == 0) {
      //   this.IsShow = true;
      //   this.UnactiveH = 0;

      // }
    },
    //是否在线
    OfflineClick() {
      this.Onlines = this.getContextData("onlines");
      //   console.log(this.Onlines);
      this.Actives = this.getContextData("actives");
      //   console.log(this.Actives);
      this.UnactiveH = 0;
      if (this.IsShow == false) {
        this.UnactiveH2 = 100;
        this.IsShow = true;
        // this.PaginationIndex = 1;
      } else if (this.IsShow == true) {
        this.IsShow = false;
        this.UnactiveH2 = 0;
      }
      // else if (this.Onlines == 0 && this.Actives == 0) {

      //   this.IsShow = true;
      //    this.UnactiveH2 = 100;
      // }
    },
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  beforeDestroy() {
    clearTimeout(this.Time);
    this.Time = null;
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "aaa";
  src: url("../../../assets/font/NotoSans-Regular.ttf");
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
<style>
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;

    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
.el-progress__text {
  display: none;
}
.el-progress-bar__outer {
  background: #1e232a !important;
  /* width: 129px; */
  margin-left: 20px;
}
</style>
<style lang="less" scoped>
.Blocks {
  padding: 20px 20px;
  background: #0b0c0f;
  border-radius: 16px 16px 16px 16px;
  .Block_Top {
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    // span {
    //   flex: 1;
    // }
    .search {
      width: 380px;
      height: 40px;
      background: #18191e;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      // margin-left: 356px;
      display: flex;
      justify-content: space-between;
      input {
        height: 40px;
        border: none;
        margin-left: 20px;
      }
      img {
        width: 21px;
        height: 21px;
        margin-top: 12px;
        margin-right: 20px;
      }
    }
    span:nth-child(1) {
      font-size: 16px;
      font-family: SF Pro Text-Medium, SF Pro Text;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      line-height: 24px;
      -webkit-background-clip: text;
    }
  }
  .Block_list {
    .block_list_Top {
      display: flex;
      height: 62px;

      width: 1120px;
      height: 60px;
      background: #14151a;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      li {
        // border: 1px solid red;
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        line-height: 62px;
        -webkit-background-clip: text;
        // padding: 0 0 0 20px;
        img {
          width: 24px;
          height: 24px;
          margin-top: 19px;
        }
      }
      li:nth-child(1) {
        flex: 0 0 5%;
        text-align: center;
      }
      li:nth-child(2) {
        flex: 0 0 16%;
        // border: 1px solid red;
        padding-left: 10px;
      }
      // li:nth-child(3) {
      //   flex: 0 0 6%;
      // }
      li:nth-child(3) {
        flex: 0 0 8%;
      }
      li:nth-child(4) {
        flex: 0 0 10%;
        text-align: center;
        img {
          width: 13px;
          height: 13px;
          margin-top: 26px;
          margin-left: 6px;
        }
      }
      li:nth-child(5) {
        flex: 0 0 10%;
        text-align: center;
      }
      li:nth-child(6) {
        flex: 0 0 12%;
        text-align: right;
        cursor: pointer;
      }
      li:nth-child(7) {
        flex: 0 0 20%;
        text-align: center;
        cursor: pointer;
      }
      // li:nth-child(8) {
      //   flex: 0 0 12%;
      //   cursor: pointer;
      // }
      li:nth-child(8) {
        flex: 0 0 8%;
        padding: 0;
        text-align: center;
        position: relative;
        cursor: pointer;
        img {
          width: 10px;
          height: 10px;
          position: absolute;
          top: 7px;
          right: 0px;
        }
        .Unactive {
          width: 90px;
          height: 0px;
          background: #14151a;
          border-radius: 6px;
          position: absolute;
          top: 66px;
          left: 0;
          overflow: hidden;
          transition: all 0.3s;
          cursor: pointer;
          p {
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #898b8d;
            cursor: pointer;
          }
          p:hover {
            color: #00a870;
          }
          .classActive {
            font-size: 16px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #fff !important;
          }
          .classActive:hover {
            color: #00a870;
          }
        }
      }
      li:nth-child(9) {
        flex: 0 0 7%;
        padding-left: 10px;
        position: relative;
        cursor: pointer;
        img {
          width: 10px;
          height: 10px;
          position: absolute;
          top: 7px;
          right: 7px;
        }
        .Unactive {
          width: 90px;
          height: 0px;
          background: #14151a;
          border-radius: 6px;
          position: absolute;
          top: 66px;
          left: 0;
          overflow: hidden;
          transition: all 0.3s;
          text-align: center;
          cursor: pointer;
          p {
            font-size: 16px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            height: 50px;
            line-height: 50px;
            cursor: pointer;
          }
          p:hover {
            color: #00a870;
          }
          .classActive {
            font-size: 16px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #fff !important;
          }
          .classActive:hover {
            color: #00a870;
          }
        }
      }
    }
  }
  .Block_List_center {
    ul {
      min-height: 300px;
      li {
        display: flex;
        height: 62px;
        border-bottom: 1px solid #22252e;
        line-height: 62px;
        p {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
          -webkit-background-clip: text;
          //   flex: 1;
          // color: rgba(255, 255, 255, 0.9);
        }
      }
      li:last-child {
        border: none;
      }
      p:nth-child(1) {
        flex: 0 0 5%;
        text-align: center;
        // border: 1px solid red;
      }
      p:nth-child(2) {
        flex: 0 0 16%;
        position: relative;
        text-align: left;
        //  border: 1px solid red;
        span:nth-child(1) {
          display: inline-block;
          width: 28px;
          height: 28px;
          position: absolute;
          top: 20px;
          margin-right: 8px;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 28px;
            height: 28px;
          }
        }
        span:nth-child(2) {
          display: block;
          margin-left: 41px;
          height: 100%;
          // border: 1px solid red;
          .name {
            width: 120px;
            //  height: 20px;
            padding-top: 10px;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // border: 1px solid yellow;
          }
          .adressall {
            display: flex;

            .adress {
              display: inline-block;
              width: 100px;
              height: 40px;
              line-height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #fff;
              cursor: pointer;
            }
            img {
              width: 20px;
              height: 20px;
              margin-left: 110px;
              margin-top: 10px;
            }
          }
          .adress:hover {
            color: #fff;
          }
          // width: 100px;
          // height: 20px;
          // line-height: 20px;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
          // border: 1px solid yellow;
        }
        // span:nth-child(4) {
        //   display: inline-block;
        //   margin-left: 41px;
        //   height: 20px;
        //   line-height: 20px;
        //   border: 1px solid red;
        //   // margin-top: 10px;
        // }
      }
      // p:nth-child(3) {
      //   color: #00a870;
      //   cursor: pointer;
      //   flex: 0 0 8%;
      // }
      p:nth-child(3) {
        cursor: pointer;
        flex: 0 0 8%;
        text-align: center;
      }
      p:nth-child(4) {
        flex: 0 0 10%;
        text-align: center;
      }
      p:nth-child(5) {
        flex: 0 0 10%;
        text-align: center;
      }
      p:nth-child(6) {
        flex: 0 0 12%;
        text-align: center;
      }
      p:nth-child(7) {
        flex: 0 0 20%;
        text-align: center;
        display: flex;
        flex-direction: column;
        span {
          height: 30px;
          line-height: 30px;
          // border: 1px solid red;
          display: inline-block;
        }
        span:nth-child(1) {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
          margin-top: 8px;
        }
      }
      // p:nth-child(8) {
      //   flex: 0 0 12%;
      //   text-align: center;
      // }
      p:nth-child(8) {
        flex: 0 0 8%;
        text-align: center;
        img {
          width: 22px;
          height: 22px;
          margin-top: 20px;
        }
      }
      p:nth-child(9) {
        color: #00a870;
        flex: 0 0 7%;
        text-align: center;
        cursor: pointer;
      }
      .active {
        color: #e34d59 !important;
      }
    }
  }
  .Block_List_Bottom {
    margin-top: 20px;
  }
}
.Img {
  width: 100%;
  height: 400px;
  text-align: center;
  img {
    width: 350px;
    height: 250px;
    margin-top: 40px;
  }
}
</style>
